import { render } from "./PagePopup.vue?vue&type=template&id=597a1039"
import script from "./PagePopup.vue?vue&type=script&lang=js"
export * from "./PagePopup.vue?vue&type=script&lang=js"

import "./PagePopup.vue?vue&type=style&index=0&id=597a1039&lang=stylus"

import exportComponent from "C:\\projects\\_personal\\poland-shop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__